export interface ProgressAction
{
    id: string;
    target: string;
    state: 'pending'|'completed';
    startedAt: number;
    completedAt: number;
    metadata?: {[index: string]: any};
}

export abstract class ProgressModelBase extends EventTarget
{
    abstract actionStarted(target: string, metadata?: {[index: string]: any}): ProgressAction
    abstract actionCompleted(action: ProgressAction): void
    abstract getTargetActions(target: string): {pending: ProgressAction[], completed: ProgressAction[]}
}

let ProgressModel: ProgressModelBase|null = null;

function setProgressModel(model: ProgressModelBase)
{
    ProgressModel = model;
}

export { ProgressModel, setProgressModel };
